import {
  BoltIcon,
  CircleStackIcon,
  FireIcon,
  MagnifyingGlassIcon,
  PresentationChartLineIcon,
  Squares2X2Icon,
} from '@heroicons/react/24/outline';

import { Sidebar } from '@/components/layout/Sidebar';
import { CanvasRoutes, RouterConfig, Routes } from '@/configs/routes';
import { isFeatureEnabled } from '@/utils/featureFlags';

const items = Routes.filter((r) => r.showInNavigation && !r.path.slice(1).includes('/'));

const iconMap = {
  [RouterConfig[CanvasRoutes.Overview].path]: Squares2X2Icon,
  [RouterConfig[CanvasRoutes.FoundationForecasting].path]: PresentationChartLineIcon,
  [RouterConfig[CanvasRoutes.Decisions].path]: BoltIcon,
  [RouterConfig[CanvasRoutes.Data].path]: CircleStackIcon,
  [RouterConfig[CanvasRoutes.Explore].path]: MagnifyingGlassIcon,
  [RouterConfig[CanvasRoutes.Bonfire].path]: FireIcon,
};

export function Navigation() {
  const visibleItems = items.filter(
    (r) => r.path !== RouterConfig[CanvasRoutes.Bonfire].path || isFeatureEnabled('bonfireRoute'),
  );

  return (
    <Sidebar
      items={visibleItems}
      iconMap={iconMap}
      expandOnHover
      depth={0}
      expandablePaths={[
        RouterConfig[CanvasRoutes.Overview].path,
        RouterConfig[CanvasRoutes.FoundationForecasting].path,
        RouterConfig[CanvasRoutes.Decisions].path,
        RouterConfig[CanvasRoutes.Data].path,
        RouterConfig[CanvasRoutes.Explore].path,
        RouterConfig[CanvasRoutes.Bonfire].path,
      ]}
    />
  );
}
